import { imageLoader } from "@/lib/sanity/client";
import NextImageComponent from "next/image";

// Cast to fix React 17 + @types/react 18 compatibility issue
const NextImage = NextImageComponent as any;

export type ImageProps = {
  _type: "image";
  asset: {
    url: string;
  };
};

const Image: React.FC<ImageProps> = (props) => {
  const { asset } = props;
  if (asset.url) {
    return (
      <NextImage
        src={asset.url}
        layout="fill"
        objectFit="cover"
        alt={""}
        loader={imageLoader}
        priority
      />
    );
  } else {
    return null;
  }
};

export default Image;
